import formControlLabelClasses from "@mui/material/FormControlLabel/formControlLabelClasses";
import switchClasses from "@mui/material/Switch/switchClasses";
import { stripUnit } from "../../styles/utils/utils";
const colorVariation = (dt, color) => {
    return {
        [`.${switchClasses.thumb}`]: {
            backgroundColor: dt.cta.contained.color.text[color].default,
        },
        [`&.Mui-focusVisible ~ .${switchClasses.track}`]: {
            boxShadow: dt.state.focus[color],
        },
        [`&.${switchClasses.checked}`]: {
            [`& ~ .${switchClasses.track}[class]`]: {
                backgroundColor: dt.cta.contained.color.background[color].active,
            },
            [`&:hover ~ .${switchClasses.track}, *:is(.Pxl-demo-hover, [data-demostate=hover]) & ~ .${switchClasses.track}[class]`]: {
                backgroundColor: dt.cta.contained.color.background[color].hover,
            },
            [`&.Mui-focusVisible ~ .${switchClasses.track}`]: {
                backgroundColor: dt.cta.contained.color.background[color].focus,
                boxShadow: dt.state.focus[color],
            },
            [`&.${switchClasses.disabled} ~ .${switchClasses.track}`]: {
                backgroundColor: dt.cta.contained.color.background[color].disabled,
            },
        },
        [`:is(.Pxl-demo-focus, [data-demostate=focus]) .${switchClasses.checked} ~ .${switchClasses.track}`]: {
            backgroundColor: dt.cta.contained.color.background[color].focus,
        },
        [`*:is(.Pxl-demo-hover, [data-demostate=hover]) .${switchClasses.checked} ~ .${switchClasses.track}[class]`]: {
            backgroundColor: dt.cta.contained.color.background[color].hover,
        },
        [`:is(.Pxl-demo-focus, [data-demostate=focus]) & ~ .${switchClasses.track}`]: {
            boxShadow: dt.state.focus[color],
        },
    };
};
export const MuiSwitchTheme = (dt) => {
    return {
        defaultProps: {
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                margin: "12px", // Default MUI padding moved to margin.
                width: `${stripUnit(dt.switch.spacing) + stripUnit(dt.action.handle) + stripUnit(dt.switch.padding)}px`,
                height: "auto",
                padding: 0,
                overflow: "visible",
                ".MuiTouchRipple-root": {
                    display: "none",
                },
                [`&.${switchClasses.edgeStart}`]: {
                    marginLeft: 0,
                },
                [`&.${switchClasses.edgeEnd}`]: {
                    marginRight: 0,
                },
                [`.${switchClasses.track}`]: {
                    opacity: 1,
                    borderRadius: dt.borderRadius.pill,
                    height: dt.action.default,
                    backgroundColor: dt.color.palette.neutrals[70],
                },
                [`.${switchClasses.switchBase}`]: {
                    padding: dt.switch.padding,
                    top: `${(stripUnit(dt.action.default) - (stripUnit(dt.action.handle) + stripUnit(dt.switch.padding) * 2)) / 2}px`,
                    "&:hover": {
                        background: "transparent",
                    },
                },
                [`.${switchClasses.thumb}`]: {
                    width: dt.action.handle,
                    height: dt.action.handle,
                    borderRadius: dt.borderRadius.pill,
                    boxShadow: "none",
                },
                "&:hover, &:is(.Pxl-demo-hover, [data-demostate=hover])": {
                    [`.${switchClasses.track}`]: {
                        backgroundColor: dt.color.palette.neutrals[70],
                    },
                    [`.${switchClasses.thumb}`]: {
                        boxShadow: "none",
                    },
                },
                [`.Mui-focusVisible ~ .${switchClasses.track}, &:is(.Pxl-demo-focus, [data-demostate=focus]) .${switchClasses.track}`]: {
                    backgroundColor: dt.color.palette.neutrals[70],
                },
                [`.${switchClasses.disabled} ~ .${switchClasses.track}[class]`]: {
                    opacity: 1,
                    backgroundColor: dt.cta.contained.color.background.neutral.disabled,
                },
                [`.${switchClasses.checked} ~ .${switchClasses.track}[class]`]: {
                    opacity: 1,
                },
                [`.${formControlLabelClasses.labelPlacementStart} &`]: {
                    marginLeft: dt.button.gap,
                },
                ".MuiFormControlLabel-labelPlacementEnd &": {
                    marginRight: dt.button.gap,
                },
                [`.${formControlLabelClasses.labelPlacementStart} &, .MuiFormControlLabel-labelPlacementEnd &`]: {
                    [`&.${switchClasses.edgeStart}`]: {
                        marginRight: 0,
                    },
                    [`&.${switchClasses.edgeEnd}`]: {
                        marginLeft: 0,
                    },
                },
            },
            colorPrimary: colorVariation(dt, "primary"),
            colorSecondary: colorVariation(dt, "secondary"),
        },
    };
};
